<template>
  <el-button type="primary" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </el-button>
</template>
<script>
  export default {
  }
</script>
